module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\">Rentaskip</h3>\n</div>\n<div class=\"modal-body\">\n    <p> The booking fee is $4.40 including GST. This charge is non-refundable in the case of cancellation by the customer except in the event that the service is cancelled as a result of non-delivery on the day or other factor preventing the successfull delivery of the skip.</p>\n    </b>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-primary\" ng-click=\"vm.ok()\">OK</button>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/shared/services/modal/booking-fee.html
 ** module id = 166
 ** module chunks = 0
 **/